import { ProductGroupDataInterface, ProductGroupInterface } from '@lib/GTM'

import { useActiveMenuDishesQuery } from './api'

export function useProductGroups(mealKitCategoryId: string): ProductGroupDataInterface | null {

  const { data: dishesData } = useActiveMenuDishesQuery({
    variables: {
      filters: {
        categories: [mealKitCategoryId],
      },
    },
    skip: !mealKitCategoryId,
  })

  const dishesList = dishesData?.activeMenu?.menuDishes?.list
  if (!dishesList?.length) return null

  const categoryName = dishesList[0]?.mealKitCategories[0]?.title
  const categoryId = dishesList[0]?.mealKitCategories[0]?.id

  const productGroups: ProductGroupInterface[] = dishesList.map((dish) => ({
    prid: dish?.id,
    image: dish?.coverImage?.location,
    product_name: dish?.name,
    product_url: `https://www.ucook.co.za/meal-kit/${dish?.slug}`,
  }))

  return {
    category_name: categoryName,
    category_id: categoryId,
    products: productGroups,
  }
}
